// eslint-disable-next-line import/no-unresolved
import { applyUkgUserTimeZoneTransformation } from '@commonClient2/services/ukgDateTime';
import {
    BidProfileStatus, EmployeeBiddingStatus,
} from '..';
import i18n from '../../services/i18n';

/**
 * @param {BidProfileStatus|undefined} statusId
 * @param {boolean} isContainsText
 * @returns {import('@material-ui/core/styles/withStyles').CSSProperties}
 */
// eslint-disable-next-line import/prefer-default-export
export const getProfileStatusColor = (statusId, isContainsText = true) => {
    switch (statusId) {
        case BidProfileStatus.Draft:
            return {
                backgroundColor: 'white',
                border: '1px solid #B5CBE3',
                color: '#7E8E9E',
            };
        case BidProfileStatus.Scheduled:
            return {
                backgroundColor: '#CFE0FC',
                border: '1px solid #A0C2F9',
                color: '#809BC7',
            };
        case BidProfileStatus.Active:
            return {
                backgroundColor: '#E0FCCF',
                border: '1px solid #9BC281',
                color: '#507438',
            };
        case BidProfileStatus.Closed:
            return {
                backgroundColor: '#DDDDDD',
                border: '1px solid #C5C6C7',
                color: '#898A8B',
            };
        case BidProfileStatus.Published:
            return {
                backgroundColor: isContainsText ? '#DDDDDD' : 'black',
                border: '1px solid #C5C6C7',
                color: '#898A8B',
            };
        case BidProfileStatus.Canceled:
            return {
                backgroundColor: isContainsText ? '#DDDDDD' : 'black',
                border: '1px solid #C5C6C7',
                color: '#898A8B',
            };
        default:
            return {
                backgroundColor: 'white',
                border: '1px solid #000000',
                color: '#000000',
            };
    }
};

/**
 * @param {EmployeeBidProfile.IEmployeeBidProfile} profile
 * @param {boolean} isSmall
 *
 * @typedef {Object} SequentialBannerProps
 * @property {string} bannerColor
 * @property {string} fontColor
 * @property {string} bannerLabel
 * @property {boolean} hasTimer
 * @property {Date|null} sourceEndTime
 * @property {string} timerEndedText
 * @property {string} size
 * @return {SequentialBannerProps}
 */
export const getSequentialBannerProps = (profile, isSmall = true) => {
    let bannerColor = '#D6E0FF';
    let fontColor = '#317159';
    let bannerLabel = '';
    let hasTimer = false;
    let sourceEndTime = null;
    const now = applyUkgUserTimeZoneTransformation(new Date());
    if (!profile.employeeSequentialSchedule) {
        return {
            bannerColor, fontColor, bannerLabel, hasTimer: false, sourceEndTime, timerEndedText: '', size: 'sm',
        };
    }
    const myTurnStartsDate = profile.employeeSequentialSchedule.employeeSubmissionStartDate;
    const myTurnEndsDate = profile.employeeSequentialSchedule.employeeSubmissionEndDate;
    
    const isMyTurnAndUnsubmitted = profile.status === BidProfileStatus.Active
        && profile.employeeSubmissionStatus === EmployeeBiddingStatus.Unsubmitted
        && now > myTurnStartsDate;

    if (isMyTurnAndUnsubmitted) {
        if (now < myTurnEndsDate) { // My turn
            bannerColor = '#DCF2EA';
            fontColor = '#317159';
            bannerLabel = i18n.t('shiftBidding:employee.common.banner.priorityInProgress');
            if (!isSmall) {
                bannerLabel = i18n.t('shiftBidding:employee.common.banner.timeLeft');
                hasTimer = true;
                sourceEndTime = profile.employeeSequentialSchedule.employeeSubmissionEndDate;
            }
        } else if (profile.isEmployeeCanBidAfterAllottedTime) {
            bannerColor = '#FFDFA6';
            fontColor = '#66460D';
            bannerLabel = i18n.t('shiftBidding:employee.common.banner.priorityLost');
        } else {
            bannerColor = 'rgb(250,227,227)';
            fontColor = '#d32f2f';
            bannerLabel = i18n.t('shiftBidding:employee.common.banner.priorityLostCantBidAfter');
        }
    }
    return {
        bannerColor, fontColor, bannerLabel, hasTimer, sourceEndTime, timerEndedText: '', size: isSmall ? 'sm' : 'lg',
    };
};
